module.exports = __webpack_public_path__ + "img/icon_tangchuang_nor.bd008045.png";